
import { defineComponent } from "vue";

import AppLayout from "@/components/Layout/AppLayout.vue";

export default defineComponent({
  components: { AppLayout },
});
